self.onmessage = function (event) {
	fetchIndex(event.data);
};

let lastEtag = null;
const fetchIndex = (messageType) => {
	fetch("/index.html", { method: "HEAD", cache: "no-cache" })
		.then((response) => {
			const newEtag = response.headers.get("etag");

			if (lastEtag && lastEtag !== newEtag) {
				self.postMessage(messageType);
			}

			lastEtag = newEtag;
		})
		// eslint-disable-next-line no-console
		.catch(console.error);
};
